export default __webpack_public_path__ + "static/media/screen-manager.388ccbbe.svg";